import React, { useEffect, useState } from "react";

const STATUS_OPTIONS = ["ACTIVE", "INACTIVE"];

export default function CompanyDomainForm({
  mode,              // "create" | "edit"
  initialValue,      // object | null
  onSubmit,          // (payload) => void
  onCancel,          // optional
  loading,           // boolean
}) {
  const [form, setForm] = useState({
    name: "",
    company: "",
    status: "ACTIVE",
    ticketHeaderPrefix: "",
    retiredAt: "",
  });

  useEffect(() => {
    if (initialValue) {
      setForm({
        name: initialValue.name ?? "",
        company: initialValue.company ?? "",
        status: initialValue.status ?? "ACTIVE",
        ticketHeaderPrefix: initialValue.ticketHeaderPrefix ?? "",
        retiredAt: initialValue.retiredAt ?? "",
      });
    } else {
      setForm({
        name: "",
        company: "",
        status: "ACTIVE",
        ticketHeaderPrefix: "",
        retiredAt: "",
      });
    }
  }, [initialValue]);

  const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      name: form.name?.trim(),
      company: form.company?.trim(),
      status: form.status,
      ticketHeaderPrefix: form.ticketHeaderPrefix?.trim(),
      retiredAt: form.retiredAt?.trim() ? form.retiredAt.trim() : null,
    };

    onSubmit(payload);
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div className="fw-semibold">
          {mode === "create" ? "Create Company Domain" : "Edit Company Domain"}
        </div>
        {mode === "edit" && (
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
        )}
      </div>

      <div className="card-body">
        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-12">
            <label className="form-label">Domain (name)</label>
            <input
              type="text"
              className="form-control"
              placeholder="kaselog.com.sg"
              value={form.name}
              onChange={(e) => setField("name", e.target.value)}
              required
              disabled={loading}
            />
            <div className="form-text">
              Enter only the domain part (without @).
            </div>
          </div>

          <div className="col-12">
            <label className="form-label">Company Display Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="KASE LOG"
              value={form.company}
              onChange={(e) => setField("company", e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Ticket Header Prefix</label>
            <input
              type="text"
              className="form-control"
              placeholder="KLO"
              value={form.ticketHeaderPrefix}
              onChange={(e) => setField("ticketHeaderPrefix", e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={form.status}
              onChange={(e) => setField("status", e.target.value)}
              disabled={loading}
            >
              {STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>

          <div className="col-12">
            <label className="form-label">Retired At (optional)</label>
            <input
              type="text"
              className="form-control"
              placeholder="2026-01-05T10:15:30+08:00"
              value={form.retiredAt}
              onChange={(e) => setField("retiredAt", e.target.value)}
              disabled={loading}
            />
            <div className="form-text">
              Leave empty unless you want to set retirement date manually.
            </div>
          </div>

          <div className="col-12 d-flex gap-2">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Saving..." : (mode === "create" ? "Create" : "Update")}
            </button>

            {mode === "create" && (
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setForm({
                  name: "",
                  company: "",
                  status: "ACTIVE",
                  ticketHeaderPrefix: "",
                  retiredAt: "",
                })}
                disabled={loading}
              >
                Reset
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
